import { Expose, Transform } from 'class-transformer';
import { Model } from './model';
import { NameTranslations } from '../../interface';
import { PackageStatus } from '../../common';
import { addDays } from 'src/app/shared/helper';

export class Package extends Model {
  @Expose() balanceSeconds: number;
  @Expose() consumedSeconds: number;
  @Expose() currency: string;
  @Expose() discountPercent: number;
  @Expose() durationMonths: number;
  @Expose() exchangeRate: number;
  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : null))
  expiredAt: Date;
  @Expose() invitingCode: string;
  @Expose() isExtended: boolean;
  @Expose() isFreezed: boolean;
  @Expose() isRenewable: boolean;
  @Expose() isUnlimited: boolean;
  @Expose() islowAge40Notified: boolean;
  @Expose() islowAgeNotified: boolean;
  @Expose({ name: 'packageId' }) id: string;
  @Expose({ name: 'id' }) studentPackageId: string;
  @Expose() packagePrice: number;
  @Expose() packageSeconds: number;
  @Expose() paidAmount: number;
  @Expose() paymentId: string;
  @Expose() reminder: number;
  @Expose() status: PackageStatus;
  @Expose() subPrice: number;
  @Expose() transactionId: string;
  @Expose() type: string;
  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : null))
  updatedAt: Date;
  @Expose() vatPercentage: number;
  @Expose() nameTrans: NameTranslations;
  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : null))
  purchasedAt: Date | null;
  @Expose()
  packageName: string;
  @Expose() balanceMinutes: number;
  @Expose() consumedMinutes: number;
  @Expose() packageMinutes: number;
  @Expose()
  @Transform(({ obj }) => {
    if (obj && obj?.durationMonths !== null) {
      if (obj && obj?.expiredAt) {
        return addDays(obj?.durationMonths * 30, new Date(obj?.expiredAt));
      } else {
        return null;
      }
    } else {
      return null;
    }
  })
  consumedDate: Date | null;
  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : null))
  extendAt: Date | null;

  // get packageRemainingDays(): number {
  //   return Math.floor((this.expiredAt?.getTime() - this.purchasedAt?.getTime()) / (1000 * 3600 * 24))
  // }
}
